export default function BaptismPage() {
  return(
    <div class="flex items-center justify-center min-h-screen">
      <div class="text-center max-w-2xl p-6">
        <h1 className="text-3xl font-bold text-center my-6">Baptism</h1>
          <p class="text-base text-black mb-6">
            The beginning of a new life is exciting, it can also be a little frightening.  
            You may have already prayed that your baby will grow safe and well and now is a 
            good time to think about baptism. 
          </p>
          <p class="text-base text-black mb-6">
            Baptism is a time of celebration.  It is something for you and your family, 
            but it is also a special time for all the other members of the Church as all 
            the baptised are sharers in the Church’s mission to proclaim God’s love in the world. 
          </p>
          <p class="text-base text-black mb-6">
            Baptism is a time for you to grow in faith.  You may be doing this week by week as you 
            live out and celebrate your faith, but for some we recognise that this growth may have been 
            stunted by things out of your control or by personal times of hardship.  
            The baptism of your child may be an opportunity to renew your Christian faith and begin again. 
          </p>
          <p class="text-base text-black mb-6">
            You may be anxious if you’ve been out of touch with the church for a while; or if you or your 
            partner is not a Catholic, or if you are a single parent, or if you are just not sure.  
            Don’t worry!  We are here to help. 
          </p>
          <p class="text-base text-black mb-6">
            We hope that you feel welcome and part of the community that is the Parish of Our Lady Queen of Martyrs and St Swithin. 
          </p>
          <h2 class="text-2xl font-semibold text-blue-800 mt-6">What to do next</h2>
          <p class="text-base text-black mb-6">
            Please call the Parish Office, Tuesday or Thursday 9 am – 2 pm or Friday 9 am – 12 noon or complete the on-line application form.
          </p>
          <p class="text-base text-black mb-6">
            You will receive information about any Baptism Preparation meetings, and this will help to prepare you to 
            become the first and best teachers of the faith to your child.  Meetings are held in the Community room adjacent to the Church.
          </p>
          <p class="text-base text-black mb-6">
            At a later date, your child, the Godparents and guests will come to the Church for the actual Baptism. 
            The day and time for Baptism at Queen of Martyrs is Sunday at 1pm.  
            Please try to arrive a bit early so we can start on time.
          </p>
          <h2 class="text-2xl font-semibold text-blue-800 mt-6">How much does it cost?</h2>
          <p class="text-base text-black mb-6">
            A donation of £25 towards the costs of running the Church would be appreciated.
          </p>
          <h2 class="text-2xl font-semibold text-blue-800 mt-6">We look forward to celebrating Baptism with you.</h2>

          <div className="mt-12 flex justify-center">
            <a
              href="/pdfs/baptism-application-22.pdf"
              download
              className="inline-block rounded-md bg-blue-600 px-6 py-3 text-white text-sm font-medium shadow hover:bg-blue-700 transition-colors"
            >
              Download Baptism Form
            </a>
          </div>

          <div className="mt-16 w-full flex justify-center flex-col items-center space-y-6 sm:flex-row sm:space-y-0 sm:space-x-8">
            <img
              src="/pictures/IMG_5328.JPG"
              alt="Baptism 1"
              className="w-60 h-60 object-cover rounded-xl shadow-md"
            />
            <img
              src="/pictures/IMG_5330.JPG"
              alt="Baptism 2"
              className="w-60 h-60 object-cover rounded-xl shadow-md"
            />
            <img
              src="/pictures/IMG_5331.JPG"
              alt="Baptism 3"
              className="w-60 h-60 object-cover rounded-xl shadow-md"
            />
          </div>
      </div>        
    </div>
  )
}
